import { FieldValues, UseFormGetValues } from 'react-hook-form';

import { useQueryDynamicDates } from '@hooks/kpis/useQueryDynamicDates';
import { useQueryDynamicDatesPreview } from '@hooks/kpis/useQueryDynamicDatesPreview';

import { TVendorsValues } from '@enums/common';
import { EFormFields } from '@enums/kpi-api';

export const useDynamicDatesLogic = ({
	vendor,
	getValues,
}: {
	vendor: { name?: TVendorsValues; value: TVendorsValues };
	getValues: UseFormGetValues<FieldValues>;
}) => {
	const { dynamicDatesOptions, isLoadingDynamicDates } = useQueryDynamicDates(vendor?.value);

	const { dateRangePreview, isLoadingDateRangePreview } = useQueryDynamicDatesPreview({
		vendor: vendor?.value,
		dynamicDateRange: getValues(EFormFields.dynamicDateRange)?.value,
		startDateOffset: getValues(EFormFields.startDateOffset)?.value,
	});

	return {
		dynamicDatesOptions,
		dateRangePreview,
		isLoadingDynamicDates,
		isLoadingDateRangePreview,
	};
};
